"use client";

import { MeetingsService } from "@/api-client/meetings";
import { useAuthenticatedQuery } from "./use-authenticated-query";
import { getQueryKey, QUERY_KEYS } from "@/lib/query-keys";

interface UseDealMomentumParams {
  meetingId: number | null;
  enabled?: boolean;
}

export function useDealMomentum({ meetingId, enabled = true }: UseDealMomentumParams) {
  const id = meetingId != null && meetingId > 0 ? meetingId : null;

  return useAuthenticatedQuery({
    queryKey: [getQueryKey(QUERY_KEYS.DEAL_MOMENTUM, { meetingId: id ?? "" })],
    queryFn: () => {
      if (id == null) throw new Error("Meeting ID is required to fetch deal momentum");
      return MeetingsService.getDealMomentum(id);
    },
    enabled: enabled && id != null,
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
